import { render, staticRenderFns } from "./pk-markdown.vue?vue&type=template&id=77637e8f&scoped=true&"
import script from "./pk-markdown.vue?vue&type=script&lang=js&"
export * from "./pk-markdown.vue?vue&type=script&lang=js&"
import style0 from "./pk-markdown.vue?vue&type=style&index=0&id=77637e8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77637e8f",
  null
  
)

export default component.exports